// extracted by mini-css-extract-plugin
export default {"img_container":"_404_img_container__UejId","heading":"_404_heading__ePcjt","cat_logo":"_404_cat_logo__fUarr"};